import React from 'react';
import { Quote, Star } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  age: number;
  city: string;
  stars: number;
  childLabel: string;
}
const testimonials: Testimonial[] = [{
  quote: 'Lo que más me ayudó fue dejar de reaccionar desde el enojo. La guía me dio orden.',
  name: 'María López',
  age: 38,
  city: 'Miami, FL',
  stars: 5,
  childLabel: 'Mamá de una adolescente de 14 años'
}, {
  quote: 'Los scripts me quitaron el miedo de no saber qué decir. Por fin pudimos hablar sin que él se encierre en su cuarto.',
  name: 'Carolina Ramírez',
  age: 40,
  city: 'Houston, TX',
  stars: 5,
  childLabel: 'Mamá de un adolescente de 16 años'
}, {
  quote: 'No resolvimos todo en un día, pero por primera vez sentí que había un plan y no solo castigos improvisados.',
  name: 'Sofía Herrera',
  age: 45,
  city: 'Los Angeles, CA',
  stars: 4,
  childLabel: 'Mamá de un adolescente de 13 años'
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-203">
      {Array.from({
      length: 5
    }).map((_, i) => <Star key={i} className={`w-3.5 h-3.5 ${i < count ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}`} data-id="element-204" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="bg-alternate py-10 md:py-24 px-4" data-id="element-205">
      <div className="max-w-4xl mx-auto" data-id="element-206">
        <div className="text-center mb-8 md:mb-14" data-id="element-207">
          <p className="text-coral font-semibold tracking-wide text-xs md:text-sm uppercase mb-2 md:mb-3" data-id="element-208">
            Testimonios
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-209">
            Lo que más valoran las mamás de esta guía
          </h2>
          <div className="w-16 h-1 bg-coral mx-auto rounded-full" data-id="element-210"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-id="element-211">
          {testimonials.map((t, i) => <div key={i} className="bg-primary rounded-2xl p-6 md:p-7 shadow-soft border border-border flex flex-col justify-between" data-id="element-212">
              {/* Quote & Stars */}
              <div data-id="element-213">
                <div className="flex items-center justify-between mb-4" data-id="element-214">
                  <Quote className="w-8 h-8 md:w-9 md:h-9 text-coral/30 fill-coral/10" data-id="element-215" />
                  <StarRating count={t.stars} data-id="element-216" />
                </div>
                <p className="text-base md:text-lg text-text-primary font-medium italic leading-relaxed" data-id="element-217">
                  "{t.quote}"
                </p>
              </div>

              {/* Attribution */}
              <div className="flex items-center gap-3 mt-6 pt-5 border-t border-border" data-id="element-218">
                <div className="w-10 h-10 rounded-full bg-trust/15 flex items-center justify-center flex-shrink-0" data-id="element-219">
                  <span className="text-sm font-bold text-trust" data-id="element-220">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0" data-id="element-221">
                  <p className="text-sm font-bold text-text-primary truncate" data-id="element-222">
                    {t.name}, {t.age} años
                  </p>
                  <p className="text-xs text-text-secondary" data-id="element-223">{t.city}</p>
                  <p className="text-xs text-text-secondary mt-0.5" data-id="element-224">
                    {t.childLabel}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}